/* eslint-disable class-methods-use-this */
import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel, LayDcPlanFormModel } from '../../models/plan-adoption-form-models';
import { GetAmendLayDcFormContentModel, GetLayDCPreviousValues } from '../plan-amend-helper';
import { LayDcQuestionsWizard } from './lay-dc-questions-wizard';

export class LayDcAmendQuestionsWizard extends LayDcQuestionsWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendLayDcFormContentModel(content, institutionSettings);

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.LayDcAmendQuestions,
        };
    }

    getPreviousValues(): LayDcPlanFormModel {

        const previousValues = this.wizardOptions?.location?.state?.request?.values;

        if (previousValues) {
            return previousValues;
        }

        const defaultValues = this.getDefaultFormValues();
        return GetLayDCPreviousValues(this.wizardOptions?.dcPlanDetail, defaultValues);        
    }

    isIndemnificationRequired(): boolean {
        return false;
    }
}